import { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
import fcIcon from "../../assets/facebook.svg";
import igIcon from "../../assets/instagram.svg";
// import ldIcon from "../../assets/linkedin.svg";
import ytIcon from "../../assets/youtube.svg";
import tkIcon from "../../assets/tiktok.svg";
import twIcon from "../../assets/twitter.svg";
import email from "../../assets/email.svg";
// import tel from "../../assets/tel.svg";
import whatsapp from "../../assets/whatsapp.svg";
import googlePlay from "../../assets/GoogleStore.svg";
import appleStore from "../../assets/AppleStore.svg";
import {
  FooterStyle,
  Container,
  Section,
  Text,
  TextHeader,
  MobileStore,
  ListItem,
  StyledNavLink,
  ContactEmail,
  ContactTel,
  Socials,
  OutLink,
  StoreLink,
  ContactLink,
  CopyrightText,
  TelText,
} from "./footer.style";

const Footer = () => {
  const [styles, setStyles] = useState({
    contactSubSection: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      alignContent: "center",
    },

    quickLinks: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
  });

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const updateStyles = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 600) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          copyright: {
            ...prevStyles.copyright,
            fontSize: "12px",
            textAlign: "left",
          },
        }));
      } else if (screenWidth <= 430) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          copyright: {
            ...prevStyles.copyright,
            fontSize: "14px",
            textAlign: "left",
          },
        }));
      }
    };

    updateStyles();
    window.addEventListener("resize", updateStyles);

    return () => window.removeEventListener("resize", updateStyles);
  }, []);

  return (
    <FooterStyle>
      <Container>
        <Section>
          <Text>
            At GiftCard8, we are revolutionizing gift card exchange in Africa and Asia,
            prioritizing an unparalleled customer satisfaction with lucrative
            rewards for every user.
          </Text>
          <Socials>
            <OutLink href="https://www.facebook.com/Giftcard8business/" target="_blank" rel="noopener noreferrer" alt="Facebook">
              <img src={fcIcon} alt="Facebook icon" />
            </OutLink>
            <OutLink href="https://www.instagram.com/_giftcard8/" target="_blank" rel="noopener noreferrer" alt="Instagram">

              <img src={igIcon} alt="Instagram icon" />
            </OutLink>
            <OutLink href="https://www.youtube.com/@giftcard8469" target="_blank" rel="noopener noreferrer" alt="Youtube">
              <img src={ytIcon} alt="Youtube icon" />
            </OutLink>
            <OutLink href="https://www.tiktok.com/@giftcard8app" target="_blank" rel="noopener noreferrer" alt="TikTok">
              <img src={tkIcon} alt="tiktok icon" />
            </OutLink>
            <OutLink href="https://x.com/Giftcard_8" target="_blank" rel="noopener noreferrer" alt="Twitter">
              <img src={twIcon} alt="twitter icon" />
            </OutLink>
          </Socials>
        </Section>

        <div className="contact">
          <TextHeader>Contact Us</TextHeader>
          <div style={styles.contactSubSection}>
            <ContactEmail>
              <img src={email} alt="Email" />
              <ContactLink href="mailto:gcard8business@giftcard8.com" >
                support@giftcard8.com
              </ContactLink>
            </ContactEmail>

            <ContactTel>
              <img src={whatsapp} alt="Whatsapp" />
              <TelText
                href="https://api.whatsapp.com/send/?phone=8619198157166&text&type=phone_number&app_absent=0"
                style={{ color: "#fff", textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
                alt="WhatsApp"
              >
                +8619198157166
              </TelText>
            </ContactTel>
          </div>
        </div>

        <div>
          <TextHeader>Quick Links</TextHeader>
          <div style={styles.quickLinks}>
            <ListItem>
              <StyledNavLink
                to="/faqs"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="FAQs"
              >
                FAQs
              </StyledNavLink>
            </ListItem>
            <ListItem>
              <StyledNavLink
                to="/about-us"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="About Us"
              >
                About Us
              </StyledNavLink>
            </ListItem>
            <ListItem>
              <StyledNavLink
                to="/contact-us"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="Contact Us"
              >
                Contact Us
              </StyledNavLink>
            </ListItem>
            <ListItem>
              <StyledNavLink
                to="/best-rates"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="Best Rates"
              >
                Best Rate
              </StyledNavLink>
            </ListItem>
          </div>
        </div>

        <div>
          <TextHeader>User Guidelines</TextHeader>
          <div style={styles.quickLinks}>
            <ListItem>
              <StyledNavLink
                to="/terms"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="Terms of Use"
              >
                Terms of Use
              </StyledNavLink>
            </ListItem>
            <ListItem>
              <StyledNavLink
                to="/privacy"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="Privacy Policy"
              >
                Privacy Policy
              </StyledNavLink>
            </ListItem>
            <ListItem>
              <StyledNavLink
                to="/statement"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="Accessibility Statement"
              >
                Accessibility Statement
              </StyledNavLink>
            </ListItem>
            <ListItem>
              <StyledNavLink
                to="/AML-policy"
                style={styles.navLink}
                onClick={handleScrollToTop}
                alt="Anti-Money Laundering Policy"
              >
                Anti-Money Laundering Policy
              </StyledNavLink>
            </ListItem>
          </div>
        </div>

        <MobileStore>
          <TextHeader>Get the App</TextHeader>
          <StoreLink href="https://play.google.com/store/apps/details?id=com.yihua.giftcard" target="blank">
            <img src={googlePlay} alt="Google Play" />
          </StoreLink>
          <StoreLink href="https://apps.apple.com/ng/app/giftcard8-redeem-gift-cards/id6746798308" target="blank">
            <img src={appleStore} alt="Apple Store" />
          </StoreLink>
        </MobileStore>
      </Container>

      <CopyrightText>
        Copyright © {new Date().getFullYear()} GiftCard8. All Rights Reserved.
      </CopyrightText>
    </FooterStyle>
  );
};

export default Footer;
